import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import api from "services/api";

import { CampanhasView } from "./CampanhasView";
import { ICampanhaResumo } from "./types";

export interface ICResponse {
  campaignDates: {
    campaignCommunicationType: ("email" | "whatsapp")[]
    campaignStartDate: string | null;
    campaignEndDate: string | null;
    lastUpdateDate: string | null;
  };
  dataResumo: ICampanhaResumo;

  connectors: [];
  data: {
    nome: string;
    taxPayerId: string;
    parentType: "dependent" | "employee";
    // campaignType: ???? (I will validate if it returns or not)
    dateSend: Date | null;
    dateOpen: Date | null;
    dateDone: Date | null;
    status: "pending" | "done";
    campaignLink: string;
  }[];
}

export function View() {
  const { workspaceId, templateId, workspaceActivityId } = useParams() as {
    workspaceId: string;
    templateId: string;
    workspaceActivityId: string;
  };

  const { data, isFetching, isFetched, isError } = useQuery({
    queryKey: ["movimentacao", workspaceId, templateId],
    queryFn: () => api.get(`/missing-data/campaigns/${workspaceActivityId}`),
    select: (data) => data.data.data as ICResponse,
    // refetchInterval: 5000
  });

  return (
    <>
      {!isFetched && isFetching && <div>Loading...</div>}
      {!isFetched && isError && <div>Error...</div>}
      {data && <CampanhasView dates={data.campaignDates} resumo={data.dataResumo} />}
    </>
  );
}
